import { Route } from "react-router-dom";
import { ROUTES } from "../config/routes";
// import Leaves from "../pages/leaves/Leaves";
// import Profile from "../pages/profile/Profile";
import Spinner from "../components/spinner/Spinner";
import loadable from "@loadable/component";
import MainLayout from "../layouts/main-layout/MainLayout";
import Home from "../pages/home/Home";

import StandardProtocols from "../pages/sops/components/standard-protocol/StandardProtocols";
import MeetTheTeams from "../pages/sops/components/meet-the-teams/MeetTheTeams";
import DailyOperations from "../pages/sops/components/daily-operations/DailyOperations";

const options = {
    fallback: <Spinner />
}
const KnowYourCompany = loadable(() => import(/* webpackChunkName: "KnowYourCompany" */ "../pages/everything-jcr/know-your-company/KnowYourCompany"), options)
const HrPolicies = loadable(() => import(/* webpackChunkName: "HrPolicies" */ "../pages/everything-jcr/hr-policies/HrPolicies"), options)
const OurTechInfrastructure = loadable(() => import(/* webpackChunkName: "OurTechInfrastructure" */ "../pages/everything-jcr/our-tech-infrastructure/OurTechInfrastructure"), options)
const KnowledgeRepository = loadable(() => import(/* webpackChunkName: "KnowledgeRepository" */ "../pages/everything-jcr/knowledge-repository/KnowledgeRepository"), options)
const Gallery = loadable(() => import(/* webpackChunkName: "Gallery" */ "../pages/everything-jcr/gallery/Gallery"), options)
const EverythingJcr = loadable(() => import(/* webpackChunkName: "EverythingJcr" */ "../pages/everything-jcr/EverythingJcr"), options)
const Onboarding = loadable(() => import(/* webpackChunkName: "Onboarding" */ "../pages/onboarding/Onboarding"), options)
const EmployeesList = loadable(()=>import(/* webpackChunkName: "EmployeesList" */ "../pages/employees-list/EmployeesList"), options)

const Handbook = loadable(() => import(/* webpackChunkName: "Handbook" */ "../pages/handbook/Handbook"), options)
const SOPs = loadable(() => import(/* webpackChunkName: "Handbook" */ "../pages/sops/Sops"), options)
const AttendanceReport = loadable(() => import( /* webpackChunkName: "AttendanceReport" */ "../pages/attendance-report/AttendanceReport"), options)


export default (
    <Route path={ROUTES.HOME} element={<MainLayout />} >
        <Route index element={<Home />} />
        <Route path={ROUTES.ONBOARDING} element={<Onboarding />} />
        
        <Route path={ROUTES.EMPLOYEES_LIST} element={<EmployeesList />} />

        <Route path={ROUTES.ATTENDANCE_REPORT} element={<AttendanceReport />} />

        <Route path={ROUTES.SOPS} element={<SOPs />}  >
            
            <Route path={ROUTES.STANDARD_PROTOCOL} element={<StandardProtocols />} />
            <Route path={ROUTES.MEET_THE_TEAMS} element={<MeetTheTeams />} />
            <Route path={ROUTES.DAILY_OPERATIONS} element={<DailyOperations />} />
            
        </Route>
        
        <Route path={ROUTES.EVERYTHING_JCR} >
            <Route index element={<EverythingJcr />} />
            <Route path={ROUTES.KNOW_YOUR_COMPANY} element={<KnowYourCompany />} />
            {/* <Route path={ROUTES.HR_POLICIES} element={<Handbook />} /> */}
            <Route path={ROUTES.HR_POLICIES} element={<HrPolicies />} />
            <Route path={ROUTES.OUR_TECH_INFRASTRUCTURE} element={<OurTechInfrastructure />} />
            {/* <Route path={ROUTES.GALLERY} element={<Gallery />} /> */}
            {/* <Route path={ROUTES.KNOWLEDGE_REPOSITORY} element={<KnowledgeRepository />} /> */}
        </Route>
    </ Route>
)